export enum PacketValueSerialType {
    Int,
    UInt,
    Float,
    Bool,
    String,
    Vector2,
    Byte,
    Color,
    Scores
}